import { css } from '@emotion/core'
import { Theme } from 'bold-ui'

export const useDenteStyles = (theme: Theme, disableStateEffects?: boolean) => ({
  dente: css`
    max-width: 100%;
    outline: 0;
    transition: all 0.2s;
    ${!disableStateEffects &&
    `
    filter: drop-shadow(0px 2px 1px rgba(0, 0, 0, 0.04)) drop-shadow(0px 1px 5px rgba(0, 0, 0, 0.12));
    &:hover {
      filter:
        drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2));
    };`}
  `,
  active: css`
    filter: drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12))
      drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2));
  `,
  focus: css`
    fill: ${theme.pallete.primary.c40};
    opacity: 0;
    transition: opacity 0.125s;
  `,
  focusActive: css`
    opacity: 1;
  `,
  face: css`
    cursor: ${disableStateEffects ? 'inherit' : 'pointer'};
    stroke: ${theme.pallete.gray.c60};
  `,
  faceOne: css`
    fill: ${theme.pallete.gray.c90};
  `,
  faceTwo: css`
    fill: ${theme.pallete.gray.c100};
  `,
  faceActive: css`
    fill: ${theme.pallete.primary.c90};
    stroke: ${theme.pallete.primary.c40};
  `,
  faceComProtese: css`
    fill: ${theme.pallete.gray.c90};
    stroke: ${theme.pallete.gray.c60};
  `,
  faceComCondicao: css`
    fill: ${theme.pallete.gray.c90};
    stroke: ${theme.pallete.gray.c60};
  `,
  denteDisabled: css`
    filter: none;
    &:hover {
      filter: none;
    }
    &:focus {
      border: none;
    },
  `,
  faceDisabled: css`
    cursor: not-allowed;
    fill: ${!disableStateEffects && theme.pallete.gray.c90};
    stroke: ${!disableStateEffects && theme.pallete.gray.c80};
  `,
})
